import { put, call } from 'redux-saga/effects';
import { searchQueryService } from '../../services/searchService';
import * as types from '../actions';

export function* packagesSaga(params) {
  try {
      const res = yield call(searchQueryService, {
        params: {
          ...params.params,
          facetFilter: "parent"
        }, 
      }); 
      yield put({
          type: types.PUBLIC_LOAD_PACKAGES_SUCCESS,
          ...res.data.data
    });

  } catch(error) {

    yield put({ 
      type: types.PUBLIC_LOAD_PACKAGES_ERROR, 
      message: error.message
    });

  }
}